import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const CorePickerStar: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="0" height="0" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M24.6934 37.0449h-6.1739v6.1742h6.1739v-6.1742Z" />
        <path d="M24.6934 30.8711h-6.1739v6.1742h6.1739v-6.1742ZM30.8692 24.6973h-6.1739v6.1742h6.1739v-6.1742Z" />
        <path d="M18.5216 24.6973h-6.1739v6.1742h6.1739v-6.1742ZM43.2169 18.5215H37.043v6.1742h6.1739v-6.1742ZM37.0411 18.5215h-6.1739v6.1742h6.1739v-6.1742ZM12.3458 18.5215H6.17188v6.1742h6.17392v-6.1742Z" />
        <path d="M6.17391 18.5215H0v6.1742h6.17391v-6.1742ZM30.8692 12.3477h-6.1739v6.1741h6.1739v-6.1741ZM18.5216 12.3477h-6.1739v6.1741h6.1739v-6.1741Z" />
        <path d="M24.6934 6.17383h-6.1739V12.348h6.1739V6.17383Z" />
        <path d="M24.6934 0h-6.1739v6.17419h6.1739V0Z" />
      </g>
    </svg>
  </IconWrap>
);
CorePickerStar.displayName = 'CorePickerStar';

export default CorePickerStar;
